import * as React from 'react'
import { sendAmplitudeEvent, AmplitudeEvents } from '@repo/analytics/amplitude/utils'
import { localStore } from 'utils/storage'

import { AUTO_OPEN_DELAY, PROMO_POPUPS_CONFIG } from '../config'
import {
  getImageProps,
  getPopupTexts,
  injectBasillionFont,
  shouldShowPopup,
  removeBasillionFont,
} from '../utils'
import { Modal } from '../modal'
import { useTranslations } from '../../../contexts/header-config-context'

interface Props {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

export function PromoPopupLoggedInUnsubscribed({ isOpen, setIsOpen }: Props) {
  const t = useTranslations()

  React.useEffect(() => {
    injectBasillionFont()

    const timeout = setTimeout(() => {
      if (shouldShowPopup('LOGGED_IN_UNSUBSCRIBED')) {
        setIsOpen(true)
        sendAmplitudeEvent(AmplitudeEvents.PROMO_POPUP_VIEWED, {
          type: 'Logged In Unsubscribed',
        })
      }
    }, AUTO_OPEN_DELAY)

    return () => {
      clearTimeout(timeout)
      removeBasillionFont()
    }
  }, [setIsOpen])

  const { title, description, buttonText } = getPopupTexts({
    promoPopupType: 'LOGGED_IN_UNSUBSCRIBED',
    t,
  })

  return (
    <Modal
      backgroundColor="bg-[#00CCCC]"
      title={title}
      description={description}
      buttonText={buttonText}
      imageProps={getImageProps('LOGGED_IN_UNSUBSCRIBED', 1)}
      promoPopupType="LOGGED_IN_UNSUBSCRIBED"
      // oxlint-disable-next-line require-await
      onClick={async () => {
        if (typeof window !== 'undefined') {
          localStore.setString(
            PROMO_POPUPS_CONFIG.LOGGED_IN_UNSUBSCRIBED.CLOSE_KEY,
            Date.now().toString(),
          )
        }
      }}
      onClose={() => {
        sendAmplitudeEvent(AmplitudeEvents.PROMO_POPUP_CLOSED, {
          type: 'logged-in-unsubscribed',
        })
      }}
      isProcessing={false}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  )
}
